
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';


@Component({
  selector: 'app-select-option',
  templateUrl: './select-option.component.html',
  styleUrls: ['./select-option.component.scss']
})
export class SelectOptionComponent implements OnInit {
  @Input() selectOption: Array<Object>;  //select  选项
  @Input() selectedData: string; //默认选择项
  @Input() placeHolder: string = null; //提示信息
  // test:any;
  // testOptions:Array<Object>;
  @Input() minHeight: number = 180; //最低高度
  @Output() selectData: any = new EventEmitter();
  constructor() { }

  ngOnInit() {
    // this.selectedData = '58';
    // console.log(this.selectedData);
    // console.log(this.selectOption);
    // this.testOptions = JSON.parse(JSON.stringify(this.selectOption));
    // this.test = '58';
    // console.log("options:", this.testOptions);
  }
  //获取option
  getOption(event) {
    // console.log(event);
    // console.log(this.selectedData);
    this.selectData.emit(event['value']);
    // console.log("option:", event);
  }
}





// WEBPACK FOOTER //
// /data/wwwroot/xzhipin/app-client/src/app/user/select-option/select-option.component.ts